import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import "../../assets/styles/main.scss";
import "../../assets/styles/pages/login.scss";
import { SetPasswordForm } from "../../components/Forms";
import { useAppHeight } from "./subs/helpers";

export const SetPassword = withRouter((props: RouteComponentProps) => {
  const { location } = props;

  const searchParams = new URLSearchParams(location.search);

  const tokenParam = searchParams.get("token") as string;

  useAppHeight();

  return (
    <div className={"pageWrapper"} id={"loginPage"}>
      <div className="dashboard" id="login_dashboard">
        <div id="container">
          <SetPasswordForm token={tokenParam} />
        </div>
      </div>
    </div>
  );
});
